import React from "react";
import InvoiceIcon from "./Invoice";
import config from "../../../config";
import NavItem from "../../components/NavBar/NavItem";
import NavLabel from "../../components/NavBar/NavLabel";
import { systemHasPermissions } from "../../../acl/utils";
import { Acl } from "../../../accessTokenManager/AccessTokenManager";
import { connect } from "react-redux";
import { GlobalState } from "../../../redux/modules/rootReducer";
import Link from "../../components/NavBar/Link";

type Props = {
  acl: Acl;
};

export default connect((state: GlobalState) => ({
  acl: state.acl,
}))(({ acl }: Props) => {
  const { pilotInvoicePortalLink } = config;
  if (
    !pilotInvoicePortalLink ||
    !systemHasPermissions(acl, ["BACKOFFICE_PILOT_INVOICES_ACCESS"])
  ) {
    return null;
  }
  return (
    <Link href={pilotInvoicePortalLink}>
      <NavItem
        content={<NavLabel label={"Submit Invoice"} />}
        icon={<InvoiceIcon />}
      />
    </Link>
  );
});
